import { Component, OnInit } from '@angular/core';
import { PostsService } from '../posts.service';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css']
})
export class PostsComponent implements OnInit {
  public posts;
  public loading: boolean;
  public page: number = 1;
  public pageTotal: number;

  public onScroll = () => {
    if (this.page < this.pageTotal) {
      this.page++;
      console.log("SCROLLED!");
      this.loading = true;
      this.postService.getBlog(this.page).subscribe((posts) => {
        let more = _.map(posts.results, (p)=>{
          let data = p.data;
          data.uid = p.uid;
          return data;
        });
        this.posts = this.posts.concat(more);
        this.loading = false;
        console.log("POSTS: ", posts);

      });
    }

  }

  public getThumb (post) {
    return post.featured_image.Thumbnail ? post.featured_image.Thumbnail.url : post.featured_image.url;
  }


  constructor(private postService: PostsService, private titleService: Title) { }

  ngOnInit() {
    this.loading = true;
    this.titleService.setTitle("Blog -- Bender Hardware");

    this.postService.getBlog(1).subscribe((posts) => {
      this.pageTotal = posts.total_pages;
      console.log("POSTS: ", posts);
      this.posts = _.map(posts.results, (p)=>{
        let data = p.data;
        data.uid = p.uid;
        return data;
      });
      this.loading = false;

    });
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/posts/posts.component.ts